import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Bannerfrom from "../components/bannerfrom";
import { Link } from "gatsby";

function Banner(props) {
  return (
    <div className="services_location_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="Toronto">
                <h1>Mobile App Development Company New York</h1>
              </div>
              <p className="main_para">
                TekRevol is a prominent name in New York’s mobile app
                development sector. We have the capability to grow businesses of
                every scale across diverse industries. We specialize in
                inventive, scalable solutions to launch your operations to
                extraordinary heights. We have the best app developers in NYC
                who can redefine mobile experiences through top-gear disruption
                and help you acquire the perfect digital product for your
                business.
              </p>
              <Link
                to="/contact"
                className="border_btn dark_btn"
                aria-label="TekRevol Contact"
              >
                {" "}
                Let’s Get Started
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="my-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
